<!-- 头部 -->
<template>
  <div class="top f20 pL10 fb">
    <span style="color: red;" @click='titleClick'>Red</span><span style="color: #000" @click='titleClick'>Wealth</span>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {}
  },
  components: {},
  mounted () { },
  methods: {
    titleClick() {
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style>
.top{
   height: 60px;
   line-height: 60px;
   background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue